import React from 'react';

import CloseIcon from '../../../assets/images/close-icon.svg';
import ButtonWithIcon from '../../../components/shared/ButtonWithIcon/ButtonWithIcon';
import JobModal from '../../Company/ShareModal/JobShareModal/JobModal';
import SocialShareButton from '../SocialShareButton/SocialShareButton';

import styles from './JobShareModal.module.scss';

const JobShareModal = ({ isOpen, onClose, opening, onCopyLink, handleSocialShare, text, type }) => {
  if (!isOpen) return null;
  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.content}>
          <div className={styles.header}>
            <h2>{text}</h2>
            <div className={styles.closeButtonPosition}>
              <ButtonWithIcon
                img={CloseIcon}
                imgClassName="btn-icon-circular"
                variant="only-icon-circular-tertiary"
                onClick={onClose}
              />
            </div>
          </div>
          {type === 'job' && <JobModal job={opening} />}
        </div>
        {type === 'job' && <SocialShareButton handleSocialShare={handleSocialShare} onCopyLink={onCopyLink} />}
      </div>
    </div>
  );
};

export default JobShareModal;
